export interface CaptionCue {
  readonly startMs: number;
  readonly endMs: number;
  readonly text: string;
}

export interface CaptionDisplay {
  readonly trackId: string;
  readonly text: string;
  readonly startMs: number | null;
  readonly endMs: number | null;
  readonly mode: "timed" | "fallback";
}

export function getCaptionCueAt(
  cues: readonly CaptionCue[],
  positionMs: number
): CaptionCue | undefined {
  if (!Number.isFinite(positionMs) || positionMs < 0) {
    return undefined;
  }

  return cues.find(
    (cue) => positionMs >= cue.startMs && positionMs < cue.endMs
  );
}

export function getCaptionFallback(
  cues: readonly CaptionCue[],
  explicitFallback?: string
): string {
  const fallback = explicitFallback?.trim();
  if (fallback) {
    return fallback;
  }

  return cues
    .map((cue) => cue.text.trim())
    .filter((text) => text.length > 0)
    .join(" ");
}

export function toTimedCaption(
  trackId: string,
  cue: CaptionCue
): CaptionDisplay {
  return {
    trackId,
    text: cue.text,
    startMs: cue.startMs,
    endMs: cue.endMs,
    mode: "timed"
  };
}

export function toFallbackCaption(
  trackId: string,
  cues: readonly CaptionCue[],
  explicitFallback?: string
): CaptionDisplay | null {
  const text = getCaptionFallback(cues, explicitFallback);
  if (!text) {
    return null;
  }

  return {
    trackId,
    text,
    startMs: null,
    endMs: null,
    mode: "fallback"
  };
}
